import React, { useState } from "react";

import { CalendarPicker, calendarPickerClasses } from "@mui/x-date-pickers/CalendarPicker";
import Badge, { BadgeProps } from "@mui/material/Badge";
import { CalendarPickerSkeleton, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import Box from '@mui/material/Box';
import { PickersDay, pickersDayClasses, PickersDayProps } from '@mui/x-date-pickers/PickersDay';
import { pickersMonthClasses, PickersMonthClasses } from '@mui/x-date-pickers/MonthPicker'
import { ThemeProvider, createTheme, styled } from '@mui/material/styles';
import { toJS } from "mobx";
import type { } from '@mui/x-date-pickers/themeAugmentation'

const theme = createTheme({
    components: {
        // MuiYearPicker:{
        //     styleOverrides:{
        //         root:{
        //             yearButton: {

        //             },
        //         }
        //     }
        // },

        MuiPickersCalendarHeader: {
            styleOverrides: {
                label: {
                    fontSize: '2em',
                    fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
                }
            }
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    padding: '0 !important',
                    background: 'transparent !important'
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    padding: '0 !important',
                    background: '#408697 !important'
                }
            }
        },
    },
});
const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 20,
        top: 32,
        height: '6px',
        minWidth: '6px',
        border: `1px solid ${theme.palette.background.paper}`,

    },
}));

const StyledCalendar = styled(CalendarPicker<Dayjs>)(({ theme }) => ({

    [`&&.${calendarPickerClasses.root}`]: {
        boxShadow: '0 1px 4px rgba(0, 0, 0, .0705882353)',
        borderRadius: '5px',
        background: '#fff',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: 'initial'
        },
        width: '520px',
        height: '420px',

    },

}));

const CalendarWrapper = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: 'initial'
    },
}));

const DateStyle = {
    container: {

        [`&&.${calendarPickerClasses.viewTransitionContainer}`]: {
            background: '#fff'
        },
    },
    day: {
        [`&&.${pickersDayClasses.root}`]: {
            fontSize: '16px',
            fontFamily: 'monospace',
            color: 'black',
        },
        [`&&.${pickersDayClasses.dayWithMargin}`]: {
            width: '36px',
            height: '36px',


        },
        [`&&.${pickersDayClasses.dayOutsideMonth}`]: {
            color: '#CCC'

        }
    },
    month: {
        [`&&.${pickersMonthClasses.root}`]: {

        },
    }
}

export interface Event {
    _ID: string;
    date: Dayjs;
    endDate: Dayjs;
    title: string;
    description: string;
    profileId: string;
    phone?: string;
    email?: string;
    horseName?: string,
    notes?: string,
    address?: string,
    usrName?: string,
    usrEmail?: string,
    files?: Array<Object>,
    createDate?: string,
    status?: string,
    calendar_type?: string,
    public_type?: string,
    regions?: string,
    event_email?: string,
    link?: string
}
export interface Props {
    events?: Event[],
    onChange?: (event: Event[], day: Dayjs) => void,
    loading?: boolean
    onDateChange?: (date: Dayjs | null) => void
}


const App: React.FC<Props> = ({ events, onChange, loading }) => {
    const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
    const [eventDate, setEvenDate] = useState<Dayjs | null>(null);

    React.useEffect(() => {
        console.log(toJS(events));
        // if (events && events.length > 0) {
        //     setSelectedDate(events[0].date)
        // }

    }, [events])
    const handleDateClick = (date: Dayjs | null) => {
        setSelectedDate(date);
    };

    const handleEvent = (e: Event[], d: Dayjs) => {
        setEvenDate((_) => {
            onChange && onChange(e, d);
            return d;
        });
        setSelectedDate(d);

    };

    const renderDay = React.useCallback((date: Dayjs, dateRange: Dayjs[], props: PickersDayProps<Dayjs>) => {


        //const e = events ? events.filter((event) => event.date.isSame(date, 'day')) : [];
        const e = events ? events.filter((event) => {
            if (event.date.isSame(date, 'day') || event.endDate.isSame(date, 'day')) {
                return true
            } else {
                return (event.date.isBefore(date, 'day') == true) && (event.endDate.isAfter(date, 'day') == true)
            }
        }) : [];
        const eventCount = e.length;

        return (
            <>
                {eventCount > 0 && (
                    <StyledBadge color="secondary" variant="dot" overlap='circular' key={date.toString()}>
                        <PickersDay {...props} sx={DateStyle.day} onDaySelect={(date) => handleEvent(e, date)} key={date.toString()} />
                    </StyledBadge>
                )}
                {eventCount === 0 && <><PickersDay {...props} sx={DateStyle.day} onDaySelect={(date) => handleEvent(e, date)} key={date.toString()} /></>}
            </>
        );

    }, [events])

    return (
        <CalendarWrapper>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {events &&
                        <StyledCalendar
                            sx={{
                                '& .PrivatePickersYear-yearButton': {
                                    padding: "0 !important",
                                    color: "white !important",
                                    fontFamily: "Roboto, Helvetica, Arial, sans-serif !important",
                                },
                            }}
                            showDaysOutsideCurrentMonth
                            renderDay={renderDay}
                            onChange={handleDateClick}
                            date={selectedDate}
                            renderLoading={() => <CalendarPickerSkeleton></CalendarPickerSkeleton>}
                            loading={loading}
                        />

                    }


                </LocalizationProvider>
            </ThemeProvider>
        </CalendarWrapper>

    );
};

export default App;
